import {FC} from 'react'
import {KTCard} from '../../../_metronic/helpers'
import {DownloadRequestConfig} from './DownloadRequestConfig'
import {ConfigProvider} from './ConfigContext'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {Header} from './components/header/Header'
import {Table} from './table/Table'

type Props = {
  config: DownloadRequestConfig
}

const DownloadRequestPage: FC<Props> = ({config}) => (
  <ConfigProvider config={config}>
    <QueryRequestProvider>
      <QueryResponseProvider>
        <KTCard>
          <Header />
          <Table />
        </KTCard>
      </QueryResponseProvider>
    </QueryRequestProvider>
  </ConfigProvider>
)

export default DownloadRequestPage
